// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.RentalApplicationInviteStatus

export enum RentalApplicationInviteStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  DELETED = 'DELETED',
  INVITED = 'INVITED',
}

export const RentalApplicationInviteStatus_values = [
  RentalApplicationInviteStatus.ACCEPTED,
  RentalApplicationInviteStatus.DECLINED,
  RentalApplicationInviteStatus.DELETED,
  RentalApplicationInviteStatus.INVITED,
] as const;
